export interface FeaturedSlide {
  videoId: string;
  kicker: string;
  tagline: string;
}

export const featuredSlides: FeaturedSlide[] = [
  {
    videoId: "v-017",
    kicker: "本周编辑精选",
    tagline: "六个房间，六段命运，一夜之间全部交汇",
  },
  {
    videoId: "v-002",
    kicker: "高分口碑之作",
    tagline: "霓虹落雨，老城区最后一支爵士乐",
  },
  {
    videoId: "v-012",
    kicker: "短视频热度冠军",
    tagline: "六分钟，一杯咖啡，一句最后告白",
  },
  {
    videoId: "v-004",
    kicker: "亚洲影展惊喜",
    tagline: "曼谷雨季之前，天台上的那一个夏天",
  },
  {
    videoId: "v-018",
    kicker: "治愈系长片",
    tagline: "海边最后一个夏天，告别都发生在深夜",
  },
];

export const siteName = "激情视频";

export const siteIntro = {
  title: "关于激情视频",
  summary:
    "激情视频是一个专注于激情影视与精品短视频的内容平台，我们相信好的影像需要被认真对待。所有作品都经过人工筛选与分类，配合精细的标签体系与多维度筛选，让你在最短时间内找到真正想看的内容。",
  points: [
    {
      icon: "ri-shield-star-line",
      title: "精选而非海量",
      description: "每一部作品都由编辑团队完整观看后收录，拒绝无意义的数量堆积。",
    },
    {
      icon: "ri-layout-grid-line",
      title: "分类精准",
      description: "按类型、地区、年份、时长多维切分，筛选一次到位。",
    },
    {
      icon: "ri-movie-2-line",
      title: "高清画质",
      description: "收录作品的封面与画质信息完整呈现，观影体验不将就。",
    },
    {
      icon: "ri-heart-3-line",
      title: "收藏无门槛",
      description: "不需要注册登录，喜欢的作品一键收藏到本地，随时回来。",
    },
  ],
};

export const footerLinks = [
  { label: "首页", href: "/" },
  { label: "激情电影", href: "/category/movie" },
  { label: "激情短视频", href: "/category/short" },
  { label: "热门主题", href: "/category/theme" },
  { label: "搜索", href: "/search" },
  { label: "关于我们", href: "/about" },
];